export default __webpack_public_path__ + "static/media/Shipping.57cb954a.jpg";